import React, { Fragment, useEffect, useState } from 'react';
import {
  ModalFooter,
  Modal,
  ModalBody,
  ModalHeader,
  Row,
  Button,
  Label,
  CustomInput,
  Input,
  Spinner,
  Badge,
} from 'reactstrap';
import parse from 'html-react-parser'; import { Colxx } from '../../../../../../components/common/CustomBootstrap';
import {
  AxiosAPI,
  AxiosPublicAPI,
  getGroupID,
} from '../../../../../../helpers/AxiosAPI';
import Select from 'react-select';
import {
  gAPI_Response_Amadeus,
  gAPI_Response_Availability,
  postAPI_GPT_Query,
  gAPI_Rooms,
} from '../../../../../../constants/APIs';
import moment from 'moment';
const Templates = ({
  visible,
  toggleModal,
  saveAsDraft,
  handleMessage,
  sendMessage,
  quickReplies,
  channelDetails,
  propertyId,
  locale,
  messages,
  availabilityIntegration,
  conversationId,
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const [chatHistory, setChatHistory] = useState();
  const [queryArguments, setQueryArguments] = useState();
  const [questionData, setQuestionData] = useState();
  const [availableRoomsData, setAvailableRoomsData] = useState();
  const [selectedItemsList, setSelectedItemList] = useState();
  const [roomDetails, setRoomDetails] = useState([]);
  const handleSubmit = (draft) => {
    if (draft) saveAsDraft();
    else sendMessage();
    toggleModal();
  };
  const [previewText, setPreviewText] = useState('');
  const [dynamicPreview, setDynamicPreview] = useState();
  const handlePreviewChange = (e) => {
    handleMessage('user', e.target.value);
    setPreviewText(e.target.value);
  };

  useEffect(() => {
    if (messages !== undefined && messages.length > 0) {
      let history = [];
      messages.map((m) => {
        let text = m.text;
        if (
          text
            .replace(/<\/?[^>]+(>|$)/g, '')
            .replace('\r', '')
            .replace('\n', '') !== ''
        ) {
          text = text.replace(/<\/?[^>]+(>|$)/g, '');
          text.replace(/\\n/g, '');
          if (m.source === 'Bot')
            history.push({
              ai: text,
            });
          else
            history.push({
              human: text,
            });
        }
      });
      setChatHistory(history);
      AxiosAPI({
        method: 'get',
        url: `${gAPI_Rooms}/${propertyId}?lang=${locale}`,
      })
        .then((res) => {
          setRoomDetails(res.data?.rooms);
        })
        .catch((err) => console.log('err', err));
    }
  }, [propertyId]);

  const handleChange = (e) => {
    let obj = quickReplies.filter((f) => f.id === e.target.value);
    if (obj.length > 0) {
      if (
        obj[0].templateChannel === 'Email' &&
        obj[0].ttemplateType !== 'Dynamic'
      ) {
        setDynamicPreview(obj[0].message);
        let url = `${process.env.REACT_APP_CHAT_API}/question-sets`;
        setIsLoading(true);
        AxiosPublicAPI({
          method: 'get',
          url: `${url}?id=${obj[0].dynamicTemplate}`,
        }).then((res) => {
          if (res.data?.result) {
            setQuestionData(res.data.result);
            let body = {
              groupId: getGroupID(),
              propertyId: 'e655dab2-987b-4683-ad9b-599814b414b6',
              language: locale,
              q: '',
              suffix: '',
              conversationId: conversationId,
              propertyName: 'Hotel Grand',
              modelName: 'gpt-4o-mini',
              history: chatHistory,
              systemInstructions: res.data.result.instructions,
              properties: {
                check_in_date: {
                  type: 'string',
                  description: 'The check in date for room booking',
                },
                check_out_date: {
                  type: 'string',
                  description: 'The check out date for room booking',
                },
                adults: {
                  type: 'string',
                  description: 'Total number of adults (otherwise 1).',
                },
                childrens: {
                  type: 'string',
                  description: 'Total number of childrens (otherwise 0)',
                },
              },
              required: [
                'check_in_date',
                'check_out_date',
                'adults',
                'childrens',
              ],
              tools: [],
              // res.data.result.flowInvokeApi &&
              // res.data.result.flowInvokeApi?.isEnabled
              //   ? res.data.result.flowInvokeApi.json
              // : [],
            };
            let queryUrl = `${postAPI_GPT_Query}/query-chatbot-json-system`;
            AxiosPublicAPI({
              method: 'post',
              url: `${queryUrl}`,
              data: body,
            }).then((res) => {
              if (
                res.data.arguments !== undefined &&
                res.data.arguments != null
              ) {
                try {
                  let body = JSON.parse(res.data.arguments);
                  console.log(body);
                  setQueryArguments(JSON.parse(res.data.arguments));
                } catch { }
              }
              setIsLoading(false);
            });
          }
        });
      } else {
        setPreviewText(obj[0].message);
        handleMessage('user', obj[0].message);
      }
    }
  };

  const handleGenerateResponse = () => {
    if (
      availabilityIntegration !== undefined &&
      availabilityIntegration.length > 0
    ) {
      setIsLoading(true);
      let obj = availabilityIntegration[0];
      AxiosPublicAPI({
        method: 'get',
        url: `${gAPI_Response_Availability}/${obj.id
          }?group_id=${getGroupID()}&adults=${queryArguments?.adults
          }&rooms=${1}&dateIn=${moment(queryArguments?.check_in_date).format(
            'YYYY-MM-DD'
          )}&dateOut=${moment(queryArguments?.check_out_date).format(
            'YYYY-MM-DD'
          )}&children=${queryArguments?.childrens}&channel=${obj.channel}`,
      }).then((res) => {
        if (res.data?.dates && res.data.dates.length > 0) {
          let message = '';
          let options = [];
          res.data.dates.map((m) => {
            let text = dynamicPreview;
            let image = '';
            if (roomDetails !== undefined && roomDetails.length > 0) {
              image =
                roomDetails.filter(
                  (f) =>
                    (f?.provider === obj.channel || f?.provider === 'RMS') &&
                    f?.providerRoomCode == m?.roomTypeCode
                )[0]?.images[0]?.url ?? '';
            }
            text = text.replace(
              '{roomImage}',
              image === '' ? m.roomImage : image
            );
            text = text.replace('{ratePlan}', m?.selectedRate?.ratePlanName);
            text = text.replace('{price}', m?.selectedRate?.price);
            text = text.replace('{roomName}', m.roomTypeName);
            message += text;
            options.push({ value: m.roomId, label: m.roomName });
          });
          setSelectedItemList(options);
          handleMessage('user', message);
          setAvailableRoomsData(res.data.dates);
          setIsLoading(false);
        } else if (res.data?.roomTypes && res.data.roomTypes.length > 0) {
          let message = '';
          let options = [];
          res.data.roomTypes.map((m) => {
            let text = dynamicPreview;
            let image = '';
            if (roomDetails !== undefined && roomDetails.length > 0) {
              image =
                roomDetails.filter(
                  (f) =>
                    (f?.provider === obj.channel || f?.provider === 'RMS') &&
                    f?.providerRoomCode == m?.roomTypeCode
                )[0]?.images[0]?.url ?? '';
            }
            text = text.replace(
              '{roomImage}',
              image === '' ? m.roomTypeImage : image
            );
            text = text.replace('{ratePlan}', m?.minimumRate?.ratePlanName);
            text = text.replace('{price}', m?.minimumRate?.price);
            text = text.replace('{roomName}', m.roomTypeName);
            message += text;
            options.push({ value: m.roomId, label: m.roomTypeName });
          });
          console.log(options, message, 255);
          setSelectedItemList(options);
          handleMessage('user', message);
          setAvailableRoomsData(res.data.dates);
          setIsLoading(false);
        }
      });
    }
  };

  const showTemplatePreview = (index, roomName, price, ratePlan, roomImage) => {
    let text = dynamicPreview;
    text = text.replace('{roomImage}', roomImage);
    text = text.replace('{ratePlan}', ratePlan);
    text = text.replace('{price}', price);
    text = text.replace('{roomName}', roomName);
    return <Fragment>{parse(text)}</Fragment>;
  };

  const handleQueryParamenters = (e) =>
    setQueryArguments({ ...queryArguments, [e.target.name]: e.target.value });

  const handleSelectedItems = (value, { name }) => {
    if (value.length > 0) {
      let message = '';
      value.map((v) => {
        let obj = availableRoomsData.filter((a) => a.roomId === v.value);
        if (obj.length > 0) {
          let text = dynamicPreview;
          text = text.replace('{roomImage}', obj[0].roomImage);
          text = text.replace('{ratePlan}', obj[0]?.selectedRate?.ratePlanName);
          text = text.replace('{price}', obj[0]?.selectedRate?.price);
          text = text.replace('{roomName}', obj[0].roomTypeName);
          message += text;
        }
      });
      handleMessage('user', message);
    } else {
      handleMessage('user', '');
    }
  };

  return (
    <Modal
      isOpen={visible}
      toggle={toggleModal}
      wrapClassName="modal-right"
      backdrop="static"
    >
      <ModalHeader toggle={toggleModal}>Templates</ModalHeader>
      <ModalBody>
        <Row className="mb-2">
          <Colxx md="12">
            <Input className='input_sty' type="select" onChange={handleChange}>
              <option value="">Select Option</option>
              {quickReplies
                .filter((f) => f.templateChannel === 'Email')
                .map((m) => (
                  <option value={m.id}>{m.name}</option>
                ))}
            </Input>
          </Colxx>
        </Row>
        <Row className="mb-2">
          {previewText !== '' && (
            <Colxx md="12" className="my-2">
              <Label>Template Message</Label>
              <Input className='input_sty'
                type="textarea"
                onChange={handlePreviewChange}
                row={10}
                value={previewText}
              ></Input>
            </Colxx>
          )}
        </Row>
        <Row className="mb-2">
          {queryArguments !== undefined && (
            <Fragment>
              {Object.entries(queryArguments).map(([name, value]) => (
                <Colxx md="6" className="my-2">
                  <Label>{name}</Label>
                  <Input className='input_sty'
                    type="text"
                    name={name}
                    value={value}
                    onChange={handleQueryParamenters}
                  ></Input>
                </Colxx>
              ))}
            </Fragment>
          )}
        </Row>
        <Row className="mb-2">
          {queryArguments !== undefined && (
            <Colxx md="12" className="my-2 text-right">
              <Button
                color="primary"
                size="xs"
                onClick={handleGenerateResponse}
              >
                Fetch Data
              </Button>
            </Colxx>
          )}
          {previewText !== '' && (
            <Colxx md="12" className="my-2">
              <Label>Preview</Label>
              {previewText ? parse('<p>' + (typeof previewText === 'string' ? previewText : String(previewText)) + '</p>') : null}
            </Colxx>
          )}
          {availableRoomsData !== undefined &&
            availableRoomsData.length > 0 && (
              <Fragment>
                <table
                  style={{
                    width: '100%',
                    borderCollapse: 'separate',
                    borderSpacing: '10px',
                  }}
                >
                  {availableRoomsData.map((d, index) => (
                    <Fragment>
                      {showTemplatePreview(
                        index,
                        d.roomTypeName,
                        d?.selectedRate?.price,
                        d?.selectedRate?.ratePlanName,
                        d.roomImage
                      )}
                    </Fragment>
                  ))}
                </table>
                <Colxx md="12" className="my-2">
                  <Select
                    isMulti={true}
                    className="react-select"
                    classNamePrefix="react-select"
                    name="ticketType"
                    onChange={handleSelectedItems}
                    options={availableRoomsData.map((m) => {
                      return { value: m.roomId, label: m.roomTypeName };
                    })}
                  />
                </Colxx>
              </Fragment>
            )}
          {isLoading && (
            <Colxx md="12" className="my-2 text-center">
              <Spinner color="primary" className="mb-1" />
            </Colxx>
          )}
        </Row>{' '}
      </ModalBody>
      <ModalFooter>
        <Button
          color="primary"
          size="xs"
          outline
          onClick={() => handleSubmit(false)}
        >
          Send
        </Button>
        <Button
          color="primary"
          size="xs"
          outline
          onClick={() => handleSubmit(true)}
        >
          Save as Draft
        </Button>
        <Button color="secondary" size="xs" outline onClick={toggleModal}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};
export default Templates;
